import React, { useContext } from 'react';
import { func } from 'prop-types';

// Components
import { Box, Typography } from '@mui/material';
import Buttons from '../../components/Buttons';
import SummaryContent from '../../components/SummaryContent';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const SequenceStep6 = ({ next, prev }) => {
  const {
    data: { action, changeList },
  } = useContext(SequencingWizardContext);

  const textObject = {
    Prepend: {
      helperText: 'Insert at the beginning of the sequence for each location and product',
      text: (
        <Typography
          sx={{
            marginBottom: '16px',
          }}
          variant="body1"
        >
          The specified Inventory Owner order below will be <u>inserted</u> at the top of the
          sequences for the following products and locations. Any existing Inventory Owners
          currently sequenced will be moved to the next sequencing slots.
        </Typography>
      ),
    },
    Replace: {
      helperText: 'Replace the entire sequence for each location and product',
      text: (
        <Typography
          sx={{
            marginBottom: '16px',
          }}
          variant="body1"
        >
          The entire authorization sequence will be <u>replaced</u> with the specified Inventory
          Owner order for the following products and locations. Any existing Inventory Owners will
          be removed from the sequence.
        </Typography>
      ),
    },
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          overflowY: 'auto',
        }}
      >
        <Box mb={0} mt={3} mx={3} textAlign="center">
          <Typography
            sx={{
              marginBottom: '16px',
            }}
            variant="h6"
          >
            Confirm Sequencing Changes
          </Typography>
          {textObject[action].text}
          <Typography sx={{ mb: 3 }} variant="body1">
            There could be a total of {changeList.length} change{changeList.length > 1 ? 's' : ''}.
            This change can take up to 15 minutes to take affect at all locations.
          </Typography>
        </Box>
        <SummaryContent
          helperText={textObject[action].helperText}
          inventoryOwnerSubtitle="Selected Inventory Owner"
        />
      </Box>
      <Buttons
        handleLeftButtonClick={prev}
        handleRightButtonClick={next}
        leftLabel="Back"
        loadingData={false}
        rightLabel="Continue"
      />
    </>
  );
};

SequenceStep6.propTypes = {
  next: func.isRequired,
  prev: func.isRequired,
};

export default SequenceStep6;
